import { FC } from 'react'
import { v4 as uuidv4 } from 'uuid'

export const AuthStart: FC<object> = () => {
  const state = uuidv4()
  localStorage.setItem('simple.state', state)

  const searchParams = new URLSearchParams(window.location.search)
  const authorizationUrl = searchParams.get('authorization-url')

  if (authorizationUrl !== null && authorizationUrl !== '') {
    // get encoded URL from the query params
    const decodedAuthorizationUrl = atob(authorizationUrl)

    window.location.assign(`${decodedAuthorizationUrl}&state=${state}`)
  }

  return <div>Starting login process...</div>
}
